import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieNotification.css';

const CookieNotification = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const cookiesAccepted = localStorage.getItem("cookiesAccepted");
        if (!cookiesAccepted) {
            setShowBanner(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="cookie-banner">
            <p>
                This website collects cookies to deliver a better user experience. Cookies help us display personalized 
                recommendations and ensure you have a great experience. To learn more, click 
                <Link to="/privacy-policy" className="privacy-link"> Privacy Policy</Link>.
            </p>
            <button onClick={acceptCookies} className="accept-button">Accept All Cookies</button>
        </div>
    );
};

export default CookieNotification;
